import styled from 'styled-components';
import colors from 'styles/colors';

import { SaveButton as OriginalSaveButton, CancelButton as OriginalCancelButton } from 'components/Buttons';

export const Title = styled.h3`
  font-size: 14px;
  line-height: 19px;
  color: ${colors.primary};
  font-weight: 600;
`;

export const ChooseView = styled.div`
  margin-top: 15px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-top: 10px;
  padding-bottom: 30px;
  padding-right: 2px;
  border-bottom: 1px solid ${colors.primary};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SaveCancelContainer = styled.div`
  align-content: space-between;
  display: flex;
  margin-top: 30px;
`;

export const CancelButton = styled(OriginalCancelButton)`
  width: calc(50% - 0.5em);
`;

export const SaveButton = styled(OriginalSaveButton)`
  width: calc(50% - 0.5em);
`;

export const SaveNewButton = styled(OriginalSaveButton)`
  width: 100%;
`;
